module.exports = __webpack_public_path__ + "img/ring_r_e_null_null@3x.fdc4ffdb.png";